import React, { useState, useEffect } from 'react'
import { withTranslation, Trans } from 'react-i18next'
import { makeStyles } from '@material-ui/core/styles'
import { has, get } from 'lodash'
import { hyphenatedText } from 'utils/helper'

import MedTypography from '@bit/medikura.med-lib-uno.med-typography'

import InfoTooltip from 'components/InfoTooltip'
import NextButton from 'components/NextButton'
import TimeFrame from 'containers/TimeFrame'

import { TIME_FRAME_OPTION_EXACT_DATE } from '../../constants'
import { trackEvent } from 'service/tracker'

const useStyles = makeStyles(theme => ({
  contentWrapper: {
    [theme.breakpoints.up('sm')]: {
      minHeight: '18rem'
    }
  }
}))

const DrugTimeFrame = ({
  ab,
  values,
  errors,
  touched,
  itemIndex: index,
  setFieldValue,
  handleChange: formikHandleChange,
  handleBlur: formikHandleBlur,
  goNextPage,
  t
}) => {
  const classes = useStyles()

  const [displayError, setDisplayError] = useState(false)

  const isError =
    has(errors, `drugs[${index}].startDate`) ||
    (!get(values, `drugs[${index}].ongoing`) &&
      has(errors, `drugs[${index}].endDate`))

  const isTouched =
    has(touched, `drugs[${index}].startDate`) ||
    has(touched, `drugs[${index}].endDate`)

  const drugName = hyphenatedText(values.drugs[index].medicine)

  const isDisabled = !(
    get(values, `drugs[${index}].startDate.mm`) &&
    get(values, `drugs[${index}].startDate.yyyy`) &&
    (get(values, `drugs[${index}].ongoing`) ||
      (get(values, `drugs[${index}].endDate.mm`) &&
        get(values, `drugs[${index}].endDate.yyyy`)))
  )

  useEffect(() => trackEvent('PageView - Drugs Time Frame ' + (index + 1)), [])

  const checkAndProceed = () => {
    if (isError) {
      setDisplayError(true)
      trackEvent('ErrorWrongDate - Drugs Time Frame ' + (index + 1))
    } else {
      trackEvent('Submit - Drugs Time Frame ' + (index + 1))

      if (values.drugs[index].startDateRough === TIME_FRAME_OPTION_EXACT_DATE) {
        trackEvent('Submit - Drugs Time Frame Exact ' + (index + 1))
      } else {
        trackEvent('Submit - Drugs Time Frame Rough ' + (index + 1))
      }
      goNextPage()
    }
  }

  return (
    <>
      <div className={classes.contentWrapper}>
        <MedTypography variant='h2'>
          <Trans i18nKey='pages.DrugTimeFrame.heading'>
            <strong>{{ drugName }}</strong>
          </Trans>
          {/* ab === 'b' && (
            <InfoTooltip
              paragraphs={[t('pages.DrugTimeFrame.tooltip')]}
              page='DrugTimeFrame'
            />
          ) */}
        </MedTypography>
        <TimeFrame
          labels={{
            startDate: 'pages.DrugTimeFrame.startDate',
            ongoingLabel: 'common.timeFrame.stillTakeIt',
            endDate: 'pages.DrugTimeFrame.endDate'
          }}
          values={values}
          valueGroup='drugs'
          index={index}
          errors={errors}
          isError={isError}
          displayError={displayError}
          isTouched={isTouched}
          setFieldValue={setFieldValue}
          onChange={formikHandleChange}
          onBlur={formikHandleBlur}
        />
      </div>
      <NextButton disabled={isDisabled} onClick={checkAndProceed} />
    </>
  )
}

export default withTranslation()(DrugTimeFrame)
